import { render } from "./MonthSelector.vue?vue&type=template&id=0196bfa4"
import script from "./MonthSelector.vue?vue&type=script&lang=js"
export * from "./MonthSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__